'use strict';

class GatewaysConnectivityPageController {
  constructor($scope,
              $q,
              $filter,
              DashboardDataProvider) {
    const $t = $filter('translate');
    const currentDateFormat = $t('dash.panel.currentDateFormat');
    var initial = true;

    angular.extend($scope, {
      getData: getData
    });

    function getData(startDate, endDate) {
      return DashboardDataProvider.getGatewayConnectivity(startDate, endDate)
        .then((reportInfo) => {
          if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
            return [];
          }

          if (initial) {
            getLastMeasurement(reportInfo.executions[reportInfo.executions.length - 1]);
            initial = false;
          }

          return reportInfo.dictionary
            .sort((a, b) => a.id - b.id)
            .map(dictValue => ({
              label: dictValue.name,
              data: reportInfo.executions
                .map(e => ({
                  x: e.executionDateMs,
                  y: e.data?.find(datum => JSON.stringify(datum.id) === JSON.stringify(dictValue.id))?.value
                }))
                .filter(e => e.y != null)
            }))
            .filter(d => d.data.length > 0);
        });
    }

    // Get last measurement from initial call
    function getLastMeasurement(executions) {
      if (!executions) {
        return;
      }

      let info = [];
      const dictionaryHelper = [
        {
          id: 1,
          name: $t('dash.panel.reports.gatewayConnectivity.ethernet'),
          icon: 'ethernet'
        },
        {
          id: 2,
          name: $t('dash.panel.reports.gatewayConnectivity.wifi'),
          icon: 'wifi'
        },
        {
          id: 3,
          name: $t('dash.panel.reports.gatewayConnectivity.cellular'),
          icon: 'sim-card'
        }
      ];

      info.push({
        icon: 'clock',
        name: $t('dash.panel.reports.lastMeasured'),
        value: $filter('date')(executions.executionDateMs, currentDateFormat)
      });

      for (let [key, value] of Object.entries(executions.data || {})) {
        let helper = dictionaryHelper.find(el => el.id === value.id);
        if (helper) {
          info.push({
            icon: helper.icon || 'chart-line',
            name: helper.name + ' -',
            value: value.value
          });
        }
      }
      $scope.lastMeasurement = info;
    }
  }
}

export default angular
  .module('main.dashboard.gatewaysConnectivityPage.controller', [])
  .controller('GatewaysConnectivityPageController', GatewaysConnectivityPageController)
  .name;
